import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { FeatureFlag } from '@bn/primitives';
import { UserDetails } from '@bn/shared/core/api';

export interface MenuAccessProvider {
  getFeatureFlags(): Observable<UserDetails['FeatureFlags']>;
  checkFeatureFlag(featureFlag: FeatureFlag): Observable<boolean>;
  getUserDetails(): Observable<UserDetails | null>;
}

export const MENU_ACCESS = new InjectionToken<MenuAccessProvider>('MENU_ACCESS');
